<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>领货日期</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="领货日期：">
              <el-select clearable style="width: 100%" v-model="listParams.plaSupplyDateId" placeholder="请选择领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.id" :key="item.id" :label="item.title"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table class="mgt10" slot="content" :data="tableData" border>
        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

        <el-table-column prop="supplyDate" align="center" label="领货日期">
          <template slot-scope="scope">
            <span v-if="scope.row.supplyDate">
              {{ scope.row.supplyDate | formatDate }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="salesDeadline" align="center" label="下单截止日期">
          <template slot-scope="scope">
            <span>{{ scope.row.salesDeadline | formatDate(true) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="140px">
          <el-form-item label="领货日期：" prop="supplyDate">
            <el-date-picker @change="changeSupplyDate" size="small" :picker-options="supplyDateOptions" style="width: 100%" v-model="itemParams.supplyDate" type="date" placeholder="请选择领货日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="下单截止日期：" prop="salesDeadline">
            <el-radio v-model="isDefault" label="1">默认(领货日期前两天)</el-radio>
            <br />
            <el-radio v-model="isDefault" label="2">
              <el-date-picker
                :disabled="dateDisabled"
                @change="changeSalesDeadline"
                size="small"
                :picker-options="salesDeadlineOptions"
                style="width: 200px"
                v-model="itemParams.salesDeadline"
                type="date"
                placeholder="请选择下单截止日期"
              >
              </el-date-picker>

              <el-time-select
                :disabled="dateDisabled"
                v-model="specificDate"
                size="small"
                :picker-options="{
                  start: '00:00',
                  step: '01:00',
                  end: '23:00',
                }"
                placeholder="请选择具体时间"
              >
              </el-time-select>
            </el-radio>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveAdd"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      supplyDateOptions: this.supplyDateRules(),
      salesDeadlineOptions: this.salesDeadlineRules(),
      listParams: {
        supplyId: "",
        plaSupplyDateId: "",
      },
      dateList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      itemParams: {
        supplyId: "",
        supplyDate: "",
        salesDeadline: "",
      },
      isDefault: "1",
      dateDisabled: true,
      checkItemParams: {
        supplyDate: [{ required: true, message: "请选择领货日期", trigger: "change" }],
      },
      isDisabled: false,
      specificDate: "",
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadDateList();
    this.loadTableData();
  },
  methods: {
    supplyDateRules() {
      const _self = this;
      return {
        disabledDate(time) {
          if (_self.itemParams.salesDeadline) {
            return time.getTime() < _self.itemParams.salesDeadline;
          } else {
            return time && time.valueOf() <= Date.now();
          }
        },
      };
    },
    salesDeadlineRules() {
      const _self = this;
      return {
        disabledDate(time) {
          if (_self.itemParams.supplyDate) {
            return _self.itemParams.supplyDate < time.getTime() || time.valueOf() < Date.now();
          } else {
            return time && time.valueOf() < Date.now();
          }
        },
      };
    },
    changeSupplyDate(val) {
      this.itemParams.supplyDate = new Date(val).getTime();
    },
    changeSalesDeadline(val) {
      this.itemParams.salesDeadline = new Date(val).getTime();
    },
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/good/supplydate/findAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dateList = res.body.data;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/good/supplydate/findByPage",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          plaSupplyDateId: this.listParams.plaSupplyDateId,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 父组件获取子组件传递的开始日期
     * @param startAttr
     * @param startDate
     */
    getStartDate(startAttr, startDate) {
      if (startDate !== "") {
        this.itemParams[startAttr] = new Date(startDate).getTime();
      } else {
        this.itemParams[startAttr] = "";
      }
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.isDefault = "1";
      this.specificDate = "";
      this.dialogVisible = true;
      this.dialogTitle = "新增领货日期";
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this;
    },
    /**
     * 保存新增或修改
     */
    saveAdd() {
      this.isDisabled = true;
      this.$refs.dialogForm.validate(valid => {
        if (valid) {
          if (this.isDefault === "2" && !this.itemParams.salesDeadline) {
            this.$message.error("请选择下单截止日期");
            this.isDisabled = false;
          } else {
            const itemParams = Object.assign({}, this.itemParams);
            if (this.isDefault === "1") {
              itemParams.salesDeadline = itemParams.supplyDate - 2 * (24 * 60 * 60 * 1000);
            }
            if (itemParams.salesDeadline >= itemParams.supplyDate) {
              this.$message.error("下单截止日期不能超过领货日期");
              this.isDisabled = false;
              return;
            }
            itemParams.supplyId = parseInt(this.$route.params.supplyId);
            if (this.specificDate) {
              itemParams.salesDeadline = new Date(itemParams.salesDeadline).setHours(parseInt(this.specificDate));
            }
            this.$http({
              url: global.apiUrl + "/good/supplydate",
              method: "POST",
              body: itemParams,
            })
              .then(res => {
                if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                  this.dialogVisible = false;
                  this.isDisabled = false;
                  this.$message.success(res.body.info);
                  this.loadTableData();
                } else {
                }
              })
              .catch(err => {
                this.isDisabled = false;

                console.error(err);
              });
          }
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/good/supplydate",
        method: "DELETE",
        params: {
          id: id,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
  watch: {
    isDefault(val, oldVal) {
      if (val === "1") {
        this.dateDisabled = true;
        this.itemParams.salesDeadline = "";
        this.specificDate = "";
      } else {
        this.dateDisabled = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
.el-picker-panel__footer {
  .el-button--text {
    display: none !important;
  }
}
</style>
